import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isRanking", "innerRef"];
/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { TableBodyCell } from '../table-cell';
var rankingStyles = css({
  boxSizing: 'border-box'
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var RankableTableBodyCell = function RankableTableBodyCell(_ref) {
  var isRanking = _ref.isRanking,
    innerRef = _ref.innerRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(TableBodyCell, _extends({
    css: isRanking && rankingStyles
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, props, {
    innerRef: innerRef
  }));
};